import { Group } from "three";

import {
  ConstraintMetadataEntry,
  EdgeStructure,
  PointMetadata,
} from "../../lib/ik/metadata";
import { Context } from "../context";

export interface TrackingDataManagerOptions {
  trackingFps: number;
  bufferLengthSeconds: number;
  indexBufferConsideredLive: number;
}

export interface WorkerContext {
  gamePk: number;
  playId?: string;

  windowOrigin: string;

  bearerToken?: string;

  skeletalBasePath?: string;
  skeletalApiDomain?: string;

  assetBase: string;

  model: {
    name: string;
    group?: Group;
  };

  edgeStructure: EdgeStructure;
  constrData: ConstraintMetadataEntry[];
  pointData: PointMetadata;
  trackingManagerOptions: TrackingDataManagerOptions;
}

export function fromMainContext(context: Context): WorkerContext | undefined {
  if (
    context.modelTemplate &&
    context.edgeStructure &&
    context.constrData &&
    context.pointData &&
    context.options.assetBase
  ) {
    let assetBasePrefix = "";
    if (context.options.assetBase.startsWith("/")) {
      assetBasePrefix = window.origin;
    }
    return {
      gamePk: context.options.gamePk,
      playId: context.options.playId,
      skeletalBasePath: context.options.trackingApiBasePath,
      skeletalApiDomain: context.options.trackingApiDomain,
      windowOrigin: window.origin,
      assetBase: assetBasePrefix + context.options.assetBase,
      model: {
        name: context.state.modelName,
      },
      bearerToken: context.options.bearerToken,
      edgeStructure: context.edgeStructure,
      constrData: context.constrData,
      pointData: context.pointData,
      trackingManagerOptions: {
        trackingFps: context.trackingFps,
        bufferLengthSeconds: context.frames.getSize() / context.trackingFps,
        indexBufferConsideredLive: 2,
      },
    };
  } else {
    return undefined;
  }
}
